import { emptyFragment } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import Description from '../../../../../Details/Description';
import Title from '../../../../../Details/Title';
import { previewStore } from '../../../LearningCollectionPreviewStore';
import PreviewModeOrgLogo from './OrgLogo';

interface Props {
  onChange: ((value: string) => void) | (() => void);
  mode: 'builderV2' | 'Preview';
}

function LearningCollectionDetails({ onChange, mode }: Props) {
  switch (previewStore.state.kind) {
    case 'error':
    case 'loading':
    case 'waiting':
    case 'publish-celebration':
    case 'save-celebration':
    case 'discarding-changes':
      return emptyFragment();
    case 'publishing':
    case 'creating':
    case 'save-and-editing':
    case 'confirming-cancel':
    case 'confirming-cancel-from-publish':
    case 'confirming-cancel-from-create':
    case 'confirming-cancel-from-save-and-edit':
    case 'recommendations-incoming':
    case 'ready':
    case 'saving-from-publishing':
    case 'saving-from-creating':
    case 'saving-from-save-and-editing':
      const { name, description } = previewStore.state.resource.payload;
      return (
        <div className="flex pb-10 justify-between">
          <div className="md:mr-11 w-[70%]">
            <Title name={name} onChange={onChange} mode={mode} />
            <Description description={description} />
          </div>
          <PreviewModeOrgLogo resource={previewStore.state.resource} />
        </div>
      );
  }
}

export default observer(LearningCollectionDetails);
